import React from "react";
import { useNavigate } from "react-router-dom";
import backSquareIcon from "../../../assets/images/icons/billing/back-square.svg";

// Shared "BACK" control used across the billing screens, matching the Figma back-square icon
// (Spending Controls is the one billing screen that doesn't show this control - left out there).
export default function BillingBackButton({ to = "/ads/billing" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className="flex items-center gap-1.5 text-sm text-[#095228] font-semibold"
    >
      <img src={backSquareIcon} alt="" className="w-6 h-6" />
      BACK
    </button>
  );
}
